//
//
//
//
//
//
//
//
//
//
//
//

import {windVane} from '../../../utils/tmallGenius'
import {sleep} from "../../../utils/time"
import imgBase64 from '../../../items/imgBase64.vue'
//
export default {
  components: {imgBase64},
  data() {
    return {
      activeDotIdx: 0,
      dotArray: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      animationTimer: null,
      log: "设备连接中，请勿刷新页面，连接中...",
      controllerName: ""
    }
  },
  beforeRouteEnter(to, from, next) {
    windVane.setNavTitle("尝试与设备建立连接中")
    next()
  },
  /*------------------------------------------- 启动运行 -------------------------------------------------------*/
  created() {
    this.hardWareConnectDevice()
    this.controllerName = this.$route.query.name
  },
  methods: {
    /*------------------------------------------- 自定义方法 -------------------------------------------------------*/
    /*  硬件连接设备
          * */
    async hardWareConnectDevice() {
      let self = this
      let wifiList = []
      let timer = null //wifi会有多次，取最后一次
      let getWifiCnt = 0
      const GET_WIFI_TIME_INTERVAL = 3000
      console.log('开始', windVane)

      //等待几秒硬件赋值
      await sleep(3000)

      //第一步
      self.log = "开始连接..."
      windVane.connectDevice().then(res1 => {
        return new Promise((resolve, reject) => {
          //alert(JSON.stringify(res1))
          if (JSON.stringify(res1.ret).indexOf('HY_SUCCESS') < 0) {
            self.log = "连接失败，请返回后重试"
            return
          }
          self.log = "指令发送中..."
          resolve()
        })
      }).catch((e) => {
        // 失败
        self.log = "连接设备失败"
        alert("连接设备失败，请重试")
        console.log('失败', e)

      }).then(() => {
        //第二步，发送消息，获取设备信息
        return new Promise((resolve, reject) => {
          windVane.sendMessage({
            message: JSON.stringify({cmd: 79}) // string
          }).then(res2 => {
              //alert(JSON.stringify(res2))
              if (JSON.stringify(res2.ret).indexOf('HY_SUCCESS') < 0) {
                self.log = "指令失败，请返回后重试"
                return
              }
              let uid = res2.result.split("}")[0] + '}'  //硬件返回的字符串可能有乱码在尾部
              uid = JSON.parse(uid).mac //抽取字符串其中的mac属性
              self.log = "指令发送成功..."
              sessionStorage.setItem("controllerUid", uid) //后面绑定设备要用设备信息
              resolve()
            }
          ).catch(e => {
            self.log = "消息发送失败..."
            alert("连接设备失败，请重试")
            //alert("failure2: " + JSON.stringify(e));
          })
        })

      }).then(() => {
        //第三步，五次wifi指令
        self.log = "正在获取wifi列表..."
        const getWifiFinished = () => {
          clearInterval(timer)
          self.log = "获取完成，跳转中..."
          wifiList = [...new Set(wifiList)] //去重
          sessionStorage.setItem("wifiList", JSON.stringify(wifiList)) //保存下页使用
          setTimeout(() => {
            //延时后跳转
            self.$router.replace(
              "/connect/wifi/wifi?name=" +
              self.controllerName
            )
          }, 500)
        }
        setTimeout(() => {
          getWifiFinished()
        }, 10000)  //获取wifi列表倒计时，10s后强行结束
        const getWifiList = () => {
          windVane.sendMessage({
            message: JSON.stringify({cmd: 80, scanChannel: 0})
          })
            .then(res3 => {
              console.log('第3步得到的 wifi 数据', res3)
              let wifiStr = res3.result.split("]")[0] + ']'  //硬件返回的字符串可能有乱码在尾部
              if (wifiStr) {
                JSON.parse(wifiStr).forEach(item => {
                  let ssid = ''
                  if (typeof item === 'string') { //数组内部可能是字符串，可能是对象，iOs与安卓不同
                    ssid = JSON.parse(item).ssid
                  } else {
                    ssid = item.ssid
                  }
                  wifiList.push(ssid)
                })
              }
              getWifiCnt++
              if (getWifiCnt > 2) getWifiFinished()
            })
            .catch(e => {
              console.log('第3步失败', e)
            })
        }
        timer = setInterval(() => {
          getWifiList()
        }, GET_WIFI_TIME_INTERVAL)
      })
    },
    /*------------------------------------------- 绑定方法 -------------------------------------------------------*/
  }
}




// WEBPACK FOOTER //
// ./src/pages/connect/wifi/ConnectStart.vue